import * as React from "react";
import { MoreVertical16Regular } from "@fluentui/react-icons";
import { ALL_ROLES, COMPONENT_INSTANCE_POOLS, DELETE_POOL_PROMPT_STATE_KEY, EMPTY_STRING_VALUE, EVENT_HANDLER_THROTTLE_TIME, IMPORT_WEIGHTS_CODES_DATA_VIEW_POOL, IMPORT_WEIGHTS_DATA_VIEW_POOL, POOL_MODAL_HEADER, REPERTOIRE_SIDE_MENU_USAGE_POOLS_KEY, UPDATE_POOLS_ROLE, USAGE_POOL_MAINTENANCE_GENERAL_DATA_VIEW, USAGE_POOL_MAINTENANCE_TOOLBAR, USAGETOPRODUCT, USAGETOWORK } from "../../../Consts";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import { showModal, showYesNoPrompt, hideModal, showUpdateFieldsModal } from "../../../../redux/reducers/ModalReducer";
import { IYesNoPromptViewModalProps } from "../../../components/modalViews/yesNoPromptView/YesNoPromptView";
import { IRepertoireField } from "../../../types/IRepertoireField";
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { getDataAction } from "../../../components/toolBar/ToolbarHelper";
import { IActiveAccordion } from "../../../../redux/types/IActiveAccordion";
import { IResultsPerPage } from "../../../../redux/types/IResultsPerPage";
import { addTab, clearModalSearchResults, removeTab, setChangesMade, setEditableFields, sortWeightSettingsFieldData, updateUsagePoolField } from "../../../../redux/reducers/RepertoireReducer";
import UsagePoolMaintenanceToolbar, { IUsagePoolMaintenanceToolbarProps } from "../poolMaintenanceToolbar/PoolMaintenanceToolbar";
import UsagePoolMaintenanceGeneralDataView from "../poolMaintenanceGeneralDataView/PoolMaintenanceGeneralDataView";
import { IUsagePoolState } from "../../../../redux/types/IUsagePoolState";
import { ITreeData } from "../../../types/ITreeData";
import UsagePoolMaintenanceGridsView from "../poolMaintenanceGridsView/PoolMaintenanceGridsView";
import { IDataActionToolbar } from "../../../types/IDataActionToolbar";
import UsagePoolMaintenanceGeneralDataWrapperFormik from "../poolMaintenanceGeneralDataView/UsagePoolMaintenanceGeneralDataViewFormikWrapper";
import { IUsagePool } from "../../../types/usageTypes/IUsagePool";
import { IDistributionSearchQuery } from "../../../types/usageTypes/IDistributionSearchQuery";
import { IDistribution } from "../../../types/usageTypes/IDistribution";
import { IUsagesSearchQuery } from "../../../types/usageTypes/IUsagesSearchQuery";
import { IUsageGroupResult } from "../../../types/usageTypes/IUsageGroupsSearchResult";

export interface IUsagePoolMaintenancePageProps {
    usagePoolMaintenanceGeneralDataViewData: IRepertoireComponentDataItem;
    usagePoolMaintenanceToolbarData?: IRepertoireComponentDataItem;
    usagePoolMaintenanceSaveResultData?: IRepertoireComponentDataItem;
    usagePoolMaintenanceGridsViewData: IRepertoireComponentDataItem;
    weightSettingsPoolMaintenance?: IRepertoireComponentDataItem;
    usagePoolMaintenanceAllocationSettingsGridViewData: IRepertoireComponentDataItem;
    usagePoolMaintenanceWeightSettingsGridViewData: IRepertoireComponentDataItem;
    usagePoolMaintenanceWeightSettingCodesGridViewData: IRepertoireComponentDataItem;
    usagePoolMaintenanceEstimatedValuePerPointSettingsGridViewData: IRepertoireComponentDataItem;
    dataGridTableData: IRepertoireComponentDataItem;
    pool: IUsagePoolState;
    setChangesMade: typeof setChangesMade;
    activeAccordion: string[];
    updateUsagePoolField: typeof updateUsagePoolField;
    activeTab: number;
    tabs: ITabReduxItem[];
    showModal: typeof showModal;
    showYesNoPrompt: typeof showYesNoPrompt;
    hideModal: typeof hideModal;
    removeTab: typeof removeTab;
    addTab: typeof addTab;
    saveChanges: (pool: IUsagePoolState, usagePoolMaintenanceGeneralDataViewData: IRepertoireComponentDataItem) => void;
    deleteUsagePool: (poolID: number, poolCode: string, sources: ITreeData[], activeTab: number) => void;
    copyUsagePool: (dataAction: IDataActionToolbar[]) => void;
    resetMessageBanner: () => void;
    editableFieldsDataView?: IRepertoireComponentDataItem;
    setEditableFields: typeof setEditableFields;
    showUpdateFieldsModal: typeof showUpdateFieldsModal;
    updateComponentFieldsItems: (fields: IRepertoireField[],
        componentName: string,
        componentInstance: string,
        componentDataFieldName: string,
        tabs: ITabReduxItem[],
        activeTab: number) => void;
    lookupValues: ILookupDictionary;
    defaultActiveAccordions?: IActiveAccordion[];
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    editableFields: IRepertoireField[];
    sources?: ITreeData[];
    clearModalSearchResults: typeof clearModalSearchResults;
    searchPoolVersionHistory: (poolID: number, activeTabItem: ITabReduxItem, actionList: IDataActionToolbar[], sources: ITreeData[]) => void;
    roles?: string[];
    incrementTempID?: () => void;
    sortWeightSettingsFieldData: typeof sortWeightSettingsFieldData;
    updatedScroll?: number;
    useNewUIPoolMaintenanceGeneralView?: boolean;
    setValidationWarningMessage: (value: boolean) => void;
    usagePoolsSearchResults?: IUsagePool[];
    searchUsages?: (query: IUsagesSearchQuery, modalOpen: boolean, usageType: string, lookupSources: ITreeData[], continuationToken?: string) => void;
    usageGroupsSearchResult: IUsageGroupResult[];
    continuationToken?: string;
    exportUsagePoolWeightMultiplier: (pool: IUsagePoolState, poolDimensionsAndDatesID: number) => void;
    exportWeightSettingCodes: (pool: IUsagePoolState, poolDimensionsAndDatesID: number) => void;
}

interface IUsagePoolMaintenancePageState {
    toolbarWidth: number;
    isBulkCheckboxActive?: boolean;
    isChangeGeneralForm: boolean;
    isPoolAllocated?:boolean;
    distributionPoolsData?:any[],
    usageSearchType?:string;
    usageResults?:any[];
}
export type IUsagePoolMaintenanceToolbarKeys = keyof IUsagePoolMaintenancePageProps;

export class PoolMaintenancePage extends React.PureComponent<
    IUsagePoolMaintenancePageProps,
    IUsagePoolMaintenancePageState
> {
    toolbarParentRef;
    poolGeneralDataFormikRef;
    constructor(props: IUsagePoolMaintenancePageProps) {
        super(props)
        this.state = {
            toolbarWidth: null,
            isBulkCheckboxActive: false,
            isChangeGeneralForm: false,
            isPoolAllocated:false,
            usageSearchType:USAGETOWORK,
            usageResults:[]
        };
        this.toolbarParentRef = React.createRef();
        this.poolGeneralDataFormikRef = React.createRef();
        const { searchUsages,lookupValues,continuationToken } = this.props;
        if(this.props?.pool?.poolCode){
            let searchQuery: IUsagesSearchQuery = {
                usageType:USAGETOWORK,
                type:'',
                distribution:'',
                pool:this.props.pool.poolCode,
                fileName:'',
                title:'',
                composer:'',
                artist:'',
                sourceMajor: '',
                sourceMinor: '',
                rightShareOwner:'',
                allocationStatus:'',
                includeFeesInError:'',
                totalWeight: '',
                licenseesWorkNumber:'',
                matchStatus:'',
                hasOpenWorkflow:undefined,
                matchID:undefined,
                titleContains:'',
                distributionsFilter:undefined,
                sourcesFilter:undefined,
                approvalStatus:'',
                estimatedValue:undefined,
                estimatedFromValue:'',
                estimatedToValue:'',
                productType:'',
                performanceNumber:'',
                fromDate:undefined,
                toDate:undefined,
                usageUse:'',
                programName:'',
                carrierType:'',
                dimension1:'',
                dimension2:'',
                dimension3:'',
                dimension4:'',
                dimension5:'',
                venueName:''
            };
            searchUsages(searchQuery, true, USAGETOWORK, null, continuationToken || null);  
        }
    }

    componentDidMount(): void {
        setEditableFields(USAGE_POOL_MAINTENANCE_GENERAL_DATA_VIEW, COMPONENT_INSTANCE_POOLS)
    }
    componentDidUpdate(prevProps: Readonly<IUsagePoolMaintenancePageProps>, prevState: Readonly<IUsagePoolMaintenancePageState>, snapshot?: any): void {
        if (prevProps.usageGroupsSearchResult === undefined || prevProps.usageGroupsSearchResult === null) {
            return;
        }

        if (prevProps.usageGroupsSearchResult !== this.props.usageGroupsSearchResult && (this.props.usageGroupsSearchResult && this.props.usageGroupsSearchResult.length > 0)) {
            this.setState({ usageResults: this.props.usageGroupsSearchResult });
        }
        else if (prevProps.usageGroupsSearchResult !== this.props.usageGroupsSearchResult && (this.props.usageGroupsSearchResult && this.props.usageGroupsSearchResult.length === 0) && this.state.usageSearchType === USAGETOWORK) {
            const { continuationToken, searchUsages } = this.props;
            this.setState({ usageSearchType: USAGETOPRODUCT });
            if(this.props?.pool?.poolCode){
                let searchQuery: IUsagesSearchQuery = {
                    usageType: USAGETOPRODUCT,
                    type: '',
                    distribution: '',
                    pool: this.props.pool.poolCode,
                    fileName: '',
                    title: '',
                    composer: '',
                    artist: '',
                    sourceMajor: '',
                    sourceMinor: '',
                    rightShareOwner: '',
                    allocationStatus: '',
                    includeFeesInError: '',
                    totalWeight: '',
                    licenseesWorkNumber: '',
                    matchStatus: '',
                    hasOpenWorkflow: undefined,
                    matchID: undefined,
                    titleContains: '',
                    distributionsFilter: undefined,
                    sourcesFilter: undefined,
                    approvalStatus: '',
                    estimatedValue: undefined,
                    estimatedFromValue: '',
                    estimatedToValue: '',
                    productType: '',
                    performanceNumber: '',
                    fromDate: undefined,
                    toDate: undefined,
                    usageUse: '',
                    programName: '',
                    carrierType: '',
                    dimension1: '',
                    dimension2: '',
                    dimension3: '',
                    dimension4: '',
                    dimension5: '',
                    venueName: ''
                };
                searchUsages(searchQuery, true, USAGETOWORK, null, continuationToken || null)
            }
            
        }
        else if (prevProps.usageGroupsSearchResult !== this.props.usageGroupsSearchResult && (this.props.usageGroupsSearchResult && this.props.usageGroupsSearchResult.length === 0) && this.state.usageSearchType === USAGETOPRODUCT) {
            this.setState({ usageResults: this.props.usageGroupsSearchResult });
        }
    }

    handleSubmitGeneralPoolDataFormikForm = async () => {
        if (this.poolGeneralDataFormikRef.current) {
            await this.poolGeneralDataFormikRef.current.submitForm(); 
            await this.poolGeneralDataFormikRef.current.validateForm(this.poolGeneralDataFormikRef.current.values);                 
        }
    };

    saveUsagePool = async () => {
        const { saveChanges, pool, useNewUIPoolMaintenanceGeneralView, setValidationWarningMessage, usagePoolMaintenanceGeneralDataViewData } = this.props;
        this.setState({ isBulkCheckboxActive: false });

        let newPool = pool;

        if (useNewUIPoolMaintenanceGeneralView && this.poolGeneralDataFormikRef.current) {
            await this.handleSubmitGeneralPoolDataFormikForm()
            if (this.poolGeneralDataFormikRef.current.errors && Object.keys(this.poolGeneralDataFormikRef.current.errors).length > 0) {
                setValidationWarningMessage(true);
                return;
            }
            let generalPool = this.poolGeneralDataFormikRef.current.values;
         newPool = {
            ...pool, 
            cat1: generalPool.cat1,
            cat2: generalPool.cat2,
            allocationRule: generalPool?.allocationRule?.data ? generalPool.allocationRule.data: null,
            description: generalPool.description,
            distributionCategoryType: generalPool?.distributionCategoryType?.data ? generalPool.distributionCategoryType.data: null,
            invoice: generalPool.invoice,
            licenseeID: generalPool.licenseeID,
            payment: generalPool.payment,
            poolCode: generalPool.poolCode,
            isForeign: generalPool.isForeign,
            poolCategory: generalPool.poolCategory?.data ? generalPool.poolCategory.data : null
         };

            this.setIsChangeGeneralForm(false);
        }
        saveChanges(newPool, usagePoolMaintenanceGeneralDataViewData);
    }

    setIsChangeGeneralForm = (isChangeGeneralForm) => {
        this.setState({
            isChangeGeneralForm: isChangeGeneralForm
        });
    }


    deleteAction() {
        const { removeTab, usagePoolMaintenanceToolbarData, showYesNoPrompt, hideModal, activeTab } = this.props;

        const message: string = usagePoolMaintenanceToolbarData.fields.find(f => f.name === DELETE_POOL_PROMPT_STATE_KEY).data;
        const props: IYesNoPromptViewModalProps = {
            yesCallback: () => {
                this.deleteUsagePool();
                hideModal();
            },
            noCallback: () => { hideModal(); }
        }
        showYesNoPrompt(POOL_MODAL_HEADER, props, undefined, message);
    }

    deleteUsagePool() {
        const { deleteUsagePool, pool, sources, activeTab } = this.props;
        deleteUsagePool(pool.poolID, pool.poolCode, sources, activeTab);
    }

    undoChanges = () => {
        const { pool } = this.props;
        //TODO
    }

    resetMessageBanner() {
        const { resetMessageBanner } = this.props;
        resetMessageBanner();
    }

    onUpdateComponentFieldItems(fields: IRepertoireField[], componentName: string) {
        const { updateComponentFieldsItems, activeTab, tabs } = this.props;
        const dataActions = getDataAction("", USAGE_POOL_MAINTENANCE_TOOLBAR);
        updateComponentFieldsItems(fields, componentName, COMPONENT_INSTANCE_POOLS, REPERTOIRE_SIDE_MENU_USAGE_POOLS_KEY, tabs, activeTab)
    }
    changeBulkCheckbox = (value: boolean) => {
        this.setState({ isBulkCheckboxActive: value });
    }

    exportUsagePoolWeightMultiplier(poolDimensionsAndDatesID: number) {
        const { pool, exportUsagePoolWeightMultiplier } = this.props;
        exportUsagePoolWeightMultiplier(pool, poolDimensionsAndDatesID);
    }

    importUsagePoolWeightMultiplier(poolDimensionsAndDatesID: number) {
        const { pool, showModal } = this.props;
        showModal(IMPORT_WEIGHTS_DATA_VIEW_POOL, IMPORT_WEIGHTS_DATA_VIEW_POOL, { pool, poolDimensionsAndDatesID }, true, "Import pool weight settings");
    }

    exportWeightSettingCodes(poolDimensionsAndDatesID: number) {
        const { pool, exportWeightSettingCodes } = this.props;
        exportWeightSettingCodes(pool, poolDimensionsAndDatesID);
    }

    importWeightSettingCodes(poolDimensionsAndDatesID: number) {
        const { pool, showModal } = this.props;
        showModal(IMPORT_WEIGHTS_CODES_DATA_VIEW_POOL, IMPORT_WEIGHTS_CODES_DATA_VIEW_POOL, { pool, poolDimensionsAndDatesID }, true, "Import Weight Setting Codes");
    }

    render() {
        const {
            usagePoolMaintenanceGeneralDataViewData,
            usagePoolMaintenanceToolbarData,
            usagePoolMaintenanceSaveResultData,
            usagePoolMaintenanceGridsViewData,
            weightSettingsPoolMaintenance,
            usagePoolMaintenanceAllocationSettingsGridViewData,
            usagePoolMaintenanceWeightSettingsGridViewData,
            usagePoolMaintenanceWeightSettingCodesGridViewData,
            usagePoolMaintenanceEstimatedValuePerPointSettingsGridViewData,
            dataGridTableData,
            setChangesMade,
            updateUsagePoolField,
            pool,
            tabs,
            activeTab,
            showModal,
            hideModal,
            setEditableFields,
            updateComponentFieldsItems,
            editableFields,
            editableFieldsDataView,
            showUpdateFieldsModal,
            lookupValues,
            sources,
            copyUsagePool,
            clearModalSearchResults,
            searchPoolVersionHistory,
            roles,
            incrementTempID,
            sortWeightSettingsFieldData,
            updatedScroll,
            useNewUIPoolMaintenanceGeneralView,
            allResultsPerPage,
            updateUserPreferences
        } = this.props;
        const {
            isBulkCheckboxActive,
            usageResults
        } = this.state;

        if (this.props.pool && tabs[activeTab]?.usagePoolMaintenanceState) {
            const {
                poolCode,
                description,
                cat1,
                cat2,
                allocationRule,
                distributionCategoryType,
                invoice,
                poolEnabled,
                licenseeID,
                poolSources,
                poolRightTypes,
                payment,
                poolAllocationSettings,
                poolWeightSettings,
				poolWeightCodeMultiplier,
				poolWeightSettingCodes,
                poolAmountMultipliers,
                datesAndDimensions,
                weightSettingsIsEnabled,
                amountMultipliersIsEnabled,
                evppSettingsIsEnabled,
                poolEstimatedValuePerPointSettings,
                isForeign,
                poolCategory
            } = this.props.pool

            const {
                toolbarWidth,
                isChangeGeneralForm
            } = this.state;
            const isReadonly: boolean = tabs[activeTab].isReadonly;
            const isNew: boolean = tabs[activeTab].usagePoolMaintenanceState.isNew;
            const changesMade = tabs[activeTab].changesMade || (useNewUIPoolMaintenanceGeneralView && isChangeGeneralForm);

            const title = poolCode;

            return (
                <div>
                    <div><span className="title">{title}</span></div>
                    <button type="button" className="toolbar-toggle" data-toggle="collapse" data-target="#toolbarContainer">
                        <MoreVertical16Regular className="icon" aria-hidden="true" />
                    </button>
                    <div id="toolbarContainer" className="WorkMaintenanceToolbar collapse" ref={this.toolbarParentRef}>
                        <UsagePoolMaintenanceToolbar
                            scroll={updatedScroll}
                            toolbarWidth={toolbarWidth}
                            changesMade={changesMade}
                            saveResultData={usagePoolMaintenanceSaveResultData}
                            toolbarData={usagePoolMaintenanceToolbarData}
                            saveChanges={this.saveUsagePool.bind(this)}
                            deleteUsagePool={this.deleteAction.bind(this)}
                            copyUsagePool={copyUsagePool}
                            resetMessageBanner={this.resetMessageBanner.bind(this)}
                            activeTab={activeTab}
                            tabs={tabs}
                            showYesNoPrompt={showYesNoPrompt}
                            hideModal={hideModal}
                            pool={pool}
                            isReadonly={isReadonly}
                            clearModalSearchResults={clearModalSearchResults}
                            searchVersionHistory={searchPoolVersionHistory}
                            sources={sources}
                            roles={roles}
                            usageGroupsSearchResult={usageResults}
                        />
                    </div>

                    {useNewUIPoolMaintenanceGeneralView ? <UsagePoolMaintenanceGeneralDataWrapperFormik 
                        usagePoolMaintenanceGeneralDataViewData={usagePoolMaintenanceGeneralDataViewData}
                        poolCode={poolCode}
                        description={description}
                        cat1={cat1}
                        cat2={cat2}
                        allocationRule={allocationRule}
                        invoice={invoice}
                        poolEnabled={poolEnabled}
                        licenseeID={licenseeID}
                        updateUsagePoolField={updateUsagePoolField}
                        changesMade={changesMade}
                        showUpdateFieldsModal={showUpdateFieldsModal}
                        editableFieldsDataView={editableFieldsDataView}
                        dataGridTableEditableFieldsData={usagePoolMaintenanceGridsViewData}
                        setEditableFields={setEditableFields}
                        updateComponentFieldsItems={updateComponentFieldsItems}
                        editableFields={editableFields}
                        activeTab={activeTab}
                        tabs={tabs}
                        hideModal={hideModal}
                        showModal={showModal}
                        isReadonly={isReadonly}
                        isNew={isNew}
                        lookupValues={lookupValues}
                        payment={payment}
                        roles={roles}
                        dataGridTableData={dataGridTableData}
                        distributionCategoryType={distributionCategoryType}
                        poolDataFormikRef={this.poolGeneralDataFormikRef}
                        setIsChangeGeneralForm={this.setIsChangeGeneralForm}
                        isForeign={isForeign}
                        poolCategory={poolCategory}
                    /> : 
                    <UsagePoolMaintenanceGeneralDataView
                        usagePoolMaintenanceGeneralDataViewData={usagePoolMaintenanceGeneralDataViewData}
                        poolCode={poolCode}
                        description={description}
                        cat1={cat1}
                        cat2={cat2}
                        allocationRule={allocationRule}
                        invoice={invoice}
                        poolEnabled={poolEnabled}
                        licenseeID={licenseeID}
                        updateUsagePoolField={updateUsagePoolField}
                        changesMade={changesMade}
                        showUpdateFieldsModal={showUpdateFieldsModal}
                        editableFieldsDataView={editableFieldsDataView}
                        dataGridTableEditableFieldsData={usagePoolMaintenanceGridsViewData}
                        setEditableFields={setEditableFields}
                        updateComponentFieldsItems={updateComponentFieldsItems}
                        editableFields={editableFields}
                        activeTab={activeTab}
                        tabs={tabs}
                        hideModal={hideModal}
                        showModal={showModal}
                        isReadonly={isReadonly}
                        lookupValues={lookupValues}
                        payment={payment}
                        roles={roles}
                        distributionCategoryType={distributionCategoryType}
                        isForeign={isForeign}
                        poolCategory={poolCategory}
                    />}
                    <UsagePoolMaintenanceGridsView
                        weightSettingsPoolMaintenance={weightSettingsPoolMaintenance}
                        poolEnabled={poolEnabled}
                        usagePoolSources={poolSources}
                        dataGridTableData={dataGridTableData}
                        usagePoolMaintenanceGridsViewData={usagePoolMaintenanceGridsViewData}
                        usagePoolMaintenanceAllocationSettingsGridViewData={usagePoolMaintenanceAllocationSettingsGridViewData}
                        usagePoolMaintenanceWeightSettingsGridViewData={usagePoolMaintenanceWeightSettingsGridViewData}
                        usagePoolMaintenanceWeightSettingCodesGridViewData={usagePoolMaintenanceWeightSettingCodesGridViewData}
                        usagePoolMaintenanceEstimatedValuePerPointSettingsGridViewData={usagePoolMaintenanceEstimatedValuePerPointSettingsGridViewData}
                        tabs={tabs}
                        activeTab={activeTab}
                        updateUsagePoolField={updateUsagePoolField}
                        lookupValues={lookupValues}
                        componentInstance={null}
                        isReadonly={isReadonly}
                        addTab={addTab}
                        rightTypes={poolRightTypes}
                        allocationSettings={poolAllocationSettings}
                        weightSettings={poolWeightSettings}
                        weightSettingCodes={poolWeightSettingCodes}
                        lookupSources={sources}
                        poolID={this.props.pool.poolID}
                        incrementTempID={incrementTempID}
                        datesAndDimensions={datesAndDimensions}
                        saveChanges={this.saveUsagePool.bind(this)}
                        weightSettingsIsEnabled={weightSettingsIsEnabled}
                        amountMultipliersIsEnabled={amountMultipliersIsEnabled}
                        amountMultipliers={poolAmountMultipliers}
                        evppSettingsIsEnabled={evppSettingsIsEnabled}
                        poolEVPPSettings={poolEstimatedValuePerPointSettings}
                        sortWeightSettingsFieldData={sortWeightSettingsFieldData}
                        isBulkCheckboxActive={isBulkCheckboxActive}
                        changeBulkCheckbox={this.changeBulkCheckbox}
                        exportUsagePoolWeightMultiplier={this.exportUsagePoolWeightMultiplier.bind(this)}
                        importUsagePoolWeightMultiplier={this.importUsagePoolWeightMultiplier.bind(this)}
                        exportWeightSettingCodes={this.exportWeightSettingCodes.bind(this)}
                        importWeightSettingCodes={this.importWeightSettingCodes.bind(this)}
                        saveResultData={usagePoolMaintenanceSaveResultData}
                        resetMessageBanner={this.resetMessageBanner.bind(this)}
                        weightCodeMultiplier={poolWeightCodeMultiplier}
                        allResultsPerPage={allResultsPerPage}
                        updateUserPreferences={updateUserPreferences}
                    />
                </div>

            );
        }
        return <div>Loading...</div>;
    }
}

